// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginBox_container__7EeQ8","alert":"LoginBox_alert__2mI43"};